import { render, staticRenderFns } from "./SaveCohortBtnDialog.vue?vue&type=template&id=c77621f4&scoped=true"
import script from "./SaveCohortBtnDialog.vue?vue&type=script&lang=js"
export * from "./SaveCohortBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77621f4",
  null
  
)

export default component.exports